export const DEFAULT_ASSIGNMENT_LABELS = {
  candidate: "Candidate", recruiter: "Recruiter", project_owner: "Project Owner",
  support_staff: "Support Staff", unassigned: "To Be Assigned",
};
export const DEFAULT_ASSIGNMENT_KEYS = Object.keys(DEFAULT_ASSIGNMENT_LABELS);
